import React from "react";
import PurchaseItemService from "services/purchase-item";

import { connect } from "react-redux";
import { loadItem } from "reducers/purchase";

class PurchaseItem extends React.Component {
  purchaseItemService = new PurchaseItemService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.purchaseItemService
      .getAll()
      .then(({ data }) => this.props.loadItem(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { loadItem })(PurchaseItem);
